<template>
  <v-dialog v-model="dialog" fullscreen persistent>
    <v-card style="display: flex; flex-direction: column; height: 100%;">
      <v-card-title
        style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
        <div>
          <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
          <div class="text-caption text-white">{{ dialog_sub_title }}</div>
        </div>
        <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
        <v-form ref="form" class="mt-2">
          <v-row dense>
              <div class="d-flex w-100 align-center ga-2">
                <v-select
                  v-model="layoutMode"
                  :items="['Portrait', 'Landscape']"
                  label="Layout Mode"
                  variant="outlined"
                  hide-details
                  dense
                ></v-select>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-btn v-if="action != 'view'" color="darkGreen" @click="markAllYes()">
                  Mark All As "YES"
                </v-btn>
              </div>
            <v-col cols="12">
              <v-card v-if="complianceData.file.filenames.length > 0" elevation="4" class="mt-2">
                <v-card-title>File Submitted</v-card-title>
                <v-card-text>
                  <v-divider></v-divider>
                  <v-row class="mt-2">
                    <v-col v-for="file in complianceData.file.filenames" :key="file" cols="12" md="6">
                      <v-card
                        @click="selectedFile = file"
                        elevation="3"
                        append-icon="mdi-open-in-new"
                        class="mx-auto"
                        :variant="selectedFile === file ? 'outlined' : 'elevated'"
                        :color="selectedFile === file ? 'darkGreen' : undefined"
                        :title="file"
                        subtitle="application/pdf"
                      ></v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-row dense>
                <!-- LEFT: PDF Viewer -->
                <v-col cols="12" :md="layoutMode === 'Landscape' ? 12 : 7">
                  <v-card elevation="2" class="d-flex flex-column" style="height: 100%;">
                    <v-card-title class="text-subtitle-1 d-flex align-center ga-2">
                      <span>Preview</span>
                      <v-spacer></v-spacer>
                      <!-- <v-btn
                        v-if="selectedFile"
                        size="small"
                        variant="outlined"
                        color="darkGreen"
                        prepend-icon="mdi-microsoft-edge"
                        @click="openSelectedFileInEdge()"
                      >
                        Open in Edge
                      </v-btn> -->
                      <v-btn
                        v-if="selectedFile"
                        size="small"
                        variant="text"
                        color="darkGreen"
                        prepend-icon="mdi-open-in-new"
                        @click="openSelectedFileInNewTab()"
                      >
                        Open in New Tab
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0" style="flex: 1 1 auto; overflow: hidden;">
                        <div v-if="selectedFile" style="height: 100%;">
                        <iframe
                            :src="getStreamUrl(selectedFile)"
                            type="application/pdf"
                            width="100%"
                            :height="layoutMode === 'Landscape' ? '800' : '1350'"
                            style="border: none; border-radius: 12px;"
                        ></iframe>
                        </div>
                        <div v-else class="pa-4 text-center text-grey">
                        <v-icon size="40">mdi-file-pdf-box</v-icon>
                        <div class="mt-2">Click a file to preview</div>
                        </div>
                    </v-card-text>
                    </v-card>
                </v-col>

                <!-- RIGHT: Checklist -->
                <v-col
                  cols="12"
                  :md="layoutMode === 'Landscape' ? 12 : 5"
                  class="d-flex flex-column"
                  style="flex: 1 1 auto; overflow: auto; max-height: 1400px;"
                >
                  <v-progress-linear
                    v-if="loading"
                    indeterminate
                    color="primary"
                    height="5"
                    class="mt-1 rounded-lg"
                  ></v-progress-linear>

                  <div style="flex: 1 1 auto; overflow-y: auto; max-height: 100%;">
                    <v-row dense :class="layoutMode == 'Landscape' ? 'ml-1 mr-1 mt-1' : ''">
                      <v-col
                        v-for="item in checklistData"
                        :key="item.id"
                        cols="12"
                        :md="layoutMode === 'Landscape' ? 4 : 12"
                        class="d-flex flex-column"
                      >
                        <v-card class="d-flex flex-column" :class="layoutMode == 'Landscape' ? '' : 'ml-2 mr-2'" elevation="3" style="height: 100%;">
                          <v-card-text>
                            <v-row dense>
                              <v-col cols="12">
                                <div
                                  class="text-body-2 font-weight-bold"
                                  style="white-space: pre-wrap;"
                                >
                                  {{ item.indicator }}
                                </div>
                              </v-col>

                              <v-col v-if="!item.hasSubIndicators" cols="12">
                                <v-radio-group
                                  inline
                                  v-model="item.answer"
                                  size="small"
                                  row
                                  :readonly="action == 'view'"
                                >
                                  <v-radio label="Yes" value="yes" />
                                  <v-radio label="No" value="no" />
                                  <v-radio label="N/A" value="not-applicable" />
                                </v-radio-group>
                              </v-col>

                              <v-col v-if="item.answer === 'no'" cols="12">
                                <v-textarea
                                  label="Remarks"
                                  variant="outlined"
                                  rows="1"
                                  auto-grow
                                  color="darkGreen"
                                  v-model="item.remarks"
                                  :readonly="action == 'view'"
                                />
                              </v-col>

                              <v-col v-if="item.hasSubIndicators" cols="12">
                                <v-row dense>
                                  <v-col
                                    v-for="(subIndicator, index) in item.subIndicators"
                                    :key="index"
                                    cols="12"
                                  >
                                    <div>{{ subIndicator.name }}</div>
                                    <v-radio-group
                                      inline
                                      v-model="subIndicator.answer"
                                      row
                                      :readonly="action == 'view'"
                                    >
                                      <v-radio label="Yes" value="yes" />
                                      <v-radio label="No" value="no" />
                                      <v-radio label="N/A" value="not-applicable" />
                                    </v-radio-group>

                                    <v-text-field
                                      v-if="subIndicator.answer === 'no'"
                                      v-model="subIndicator.remarks"
                                      label="Remarks"
                                      variant="outlined"
                                      color="darkGreen"
                                      :readonly="action == 'view'"
                                    />
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-3" style="margin-top: auto;">
        <v-spacer></v-spacer>
        <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
        <v-btn class="mr-1" v-if="action != 'view'" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="confirmSave" width="450" persistent>
    <v-card color="secondary" rounded="lg" class="pa-2">
      <v-card-text>
        <div class="font-weight-bold mt-2 text-h6">Are you sure you want to save this checklist?</div>
        <div class="font-weight-light mt-2">
          Note: Once saved, checklists may not be updated after you return the compliance. Please review checklist
          information carefully before proceeding.
        </div>
      </v-card-text>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn @click="confirmSave = false" :disabled="loading" variant="outlined">Cancel</v-btn>
        <v-btn :loading="loading" @click="saveChecklist()" color="darkGreen" variant="elevated">Confirm</v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
  emits: ["refresh"],
  data() {
    return {
      dialog: false,
      dialog_title: null,
      dialog_sub_title: null,
      action: null,
      loading: false,
      layoutMode: 'Landscape',

      file_id: null,
      currentFileId: null, // Tracks which file's checklist is currently loaded in checklistData
      checklistData: [],
      savedChecklistData: [],
      confirmSave: false,
      newFormRules: {},
      selectedFile: null,
      serverUrl: process.env.VUE_APP_SERVER_URL
    };
  },
  methods: {
    isMobileOrTablet() {
      return window.innerWidth <= 768;
    },
    initAdd(data) {
      this.dialog = true;
      this.dialog_title = data.compliance.compliance_name + ' Checklist';
      this.dialog_sub_title = 'Add checklist for submitted compliances';
      this.action = 'add';
      this.complianceData = data;

      const incomingFileId = data.file.id;
      if (this.currentFileId !== incomingFileId || this.checklistData.length === 0) {
        this.currentFileId = incomingFileId;
        this.loadChecklist();
      }
    },
    initEdit(data) {
      this.dialog = true;
      this.dialog_title = data.compliance.compliance_name + ' Checklist';
      this.dialog_sub_title = 'Edit checklist for submitted compliances';
      this.complianceData = data;
      this.action = 'edit';

      const incomingFileId = data.file.id;
      if (this.currentFileId !== incomingFileId || this.checklistData.length === 0) {
        this.currentFileId = incomingFileId;
        this.checklistData = data.file.checklists;
        this.savedChecklistData = data.file.checklists;
      }
    },
    initView(data) {
      this.dialog = true;
      this.dialog_title = data.compliance.compliance_name + ' Checklist';
      this.dialog_sub_title = 'View checklist for submitted compliances';
      this.complianceData = data;
      this.action = 'view';

      const incomingFileId = data.file.id;
      if (this.currentFileId !== incomingFileId || this.checklistData.length === 0) {
        this.currentFileId = incomingFileId;
        this.checklistData = data.file.checklists;
        this.savedChecklistData = data.file.checklists;
      }
    },
    async loadChecklist() {
      this.loading = true;
      let res = await this.axiosCall('/compliance-checklist/findAllChecklistForCompliance/' + this.complianceData.compliance.id, 'get', null, true);
      if (res && res.data) {
        this.checklistData = res.data.map(item => ({
          ...item,
          answer: null,
          remarks: null,
          subIndicators: item.hasSubIndicators && Array.isArray(item.subIndicators)
            ? item.subIndicators.map(subIndicator => ({
              name: typeof subIndicator === "string" ? subIndicator : subIndicator.name || "",
              answer: subIndicator.answer || null,
              remarks: subIndicator.remarks || null
            }))
            : []
        }));
        this.loading = false;
      }
    },
    streamFile(file) {
      this.loading = true;
      const fileURL = this.getStreamUrl(file);
      window.open(fileURL, '_blank');
      this.loading = false;
    },
    getStreamUrl(file) {
      return `${process.env.VUE_APP_SERVER_URL}/compliance-upload/stream-file/${encodeURIComponent(file)}`;
    },
    openSelectedFileInNewTab() {
      if (!this.selectedFile) {
        return;
      }

      window.open(this.getStreamUrl(this.selectedFile), '_blank', 'noopener');
    },
    openSelectedFileInEdge() {
      const { showSnackbar } = useSnackbar()

      if (!this.selectedFile) {
        return;
      }

      const fileUrl = this.getStreamUrl(this.selectedFile);

      try {
        window.location.href = `microsoft-edge:${fileUrl}`;
        showSnackbar('Attempting to open the PDF in Microsoft Edge. If blocked, use Open in New Tab.', 'success');
      } catch (error) {
        window.open(fileUrl, '_blank', 'noopener');
        showSnackbar('Microsoft Edge could not be opened directly. The PDF was opened in a new tab instead.');
      }
    },
    checkCompletion() {
      const { showSnackbar } = useSnackbar()
      for (const item of this.checklistData) {
        if (!item.hasSubIndicators && (!item.answer || item.answer.toString().trim() === "")) {
          showSnackbar(`Please complete all indicators. Missing: ${item.indicator}`);
          return false;
        }
        if (!item.hasSubIndicators && item.answer === "no" && (!item.remarks || item.remarks.toString().trim() === "")) {
          showSnackbar(`Please provide remarks for: ${item.indicator}`);
          return false;
        }
        if (item.hasSubIndicators && Array.isArray(item.subIndicators)) {
          for (const subIndicator of item.subIndicators) {
            if (!subIndicator.answer || subIndicator.answer.toString().trim() === "") {
              showSnackbar(`Please complete all sub-indicators. Missing: ${subIndicator.name}`);
              return false;
            }
            if (subIndicator.answer === "no" && (!subIndicator.remarks || subIndicator.remarks.toString().trim() === "")) {
              showSnackbar(`Please provide remarks for: ${subIndicator.name}`);
              return false;
            }
          }
        }
      }
      return true;
    },
    async validateForm() {
      const { valid } = await this.$refs.form.validate();
      if (valid && this.checkCompletion()) {
        this.confirmSave = true;
      }
    },
    markAllYes() {
      this.checklistData = this.checklistData.map(item => {
        if (!item.hasSubIndicators) {
          return {
            ...item,
            answer: "yes",
            remarks: null
          }
        } else {
          return {
            ...item,
            subIndicators: item.subIndicators.map(sub => ({
              ...sub,
              answer: "yes",
              remarks: null
            }))
          }
        }
      })
    },
    async saveChecklist() {
      const { showSnackbar } = useSnackbar()
      this.loading = true;
      let formData = {
        file_id: this.complianceData.file.id,
        checklists: this.checklistData,
      };
      let save = await this.axiosCall('/compliance-upload/updateChecklist', 'post', formData, true)
      if(save && save.data.status == 200){
        this.loading = false;
        this.$emit('refresh', this.checklistData);
        showSnackbar('Checklist successfully saved!');
        this.confirmSave = false;
        this.dialog = false;

        this.currentFileId = null;
        this.checklistData = [];
        this.savedChecklistData = [];
        this.selectedFile = null;
      }
    },
    closeDialog() {
      this.dialog = false;
      this.selectedFile = null
    }
  }
});
</script>

<style scoped>
</style>